export const isCheckColorWhite = (bannerColor: string) => {
  const WHITE_COLORS = ['#fff', '#ffffff', 'white'];
  return WHITE_COLORS.includes(bannerColor);
};
export const defaultJmsColor = '#056D61';
